import Annotation from "./annotation";
import { setLineStyle } from "../canvasUtils";
class Grid extends Annotation {
  constructor(imgSize) {
    super();
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.stepX = 100;
    this.stepY = 100;
    this.lineWidth = 1;
    this.color = "grey";
    this.imgSize = imgSize;
  }

  draw(ctx){
    this.updateImgSize();
    if (!this.width) return;
    
    setLineStyle(ctx, this);

    for (let dx = this.x; dx <= this.width; dx += this.stepX){
      ctx.beginPath();
      ctx.moveTo(dx, this.y);
      ctx.lineTo(dx, this.height - 1);
      ctx.stroke();
      ctx.closePath();
    }

    for (let dy = this.y; dy <= this.height; dy += this.stepY){
      ctx.beginPath();
      ctx.moveTo(this.x, dy);
      ctx.lineTo(this.width - 1, dy);
      ctx.stroke();
      ctx.closePath();
    }
  }

  updateImgSize(){
    if (!this.imgSize) return;

    this.width = this.imgSize.w;
    this.height = this.imgSize.h;
    this.stepX = (this.imgSize.w - 1) / 15;
    this.stepY = (this.imgSize.h - 1) / 15;
  }
}

export default Grid;